import React, { useState } from 'react';
import Folios from './folios';
import DatoTecnico from './dato_tecnico';
import ActividadesCajas from './actividades_cajas';

const Admin = ({ }) => {

  const [activeTab, setActiveTab] = useState(1);

  const handleTabChange = (tabNumber) => {
    setActiveTab(tabNumber);
  };

  return (
    <div className="container-page-wrapper" style={{ "overflowY": "auto" }}>
      <div className="page-title">
        <h3>
          <i className="fas fa-server" /> Admin
        </h3>
      </div>

      {/** Tabs */}
      <div className='btn-tabs'>
        <button onClick={() => handleTabChange(1)} className={'btn btn-light' + (activeTab === 1 ? ' active' : '')}>Folios</button>
        <button onClick={() => handleTabChange(2)} className={'btn btn-light' + (activeTab === 2 ? ' active' : '')}>Dato técnico</button>
        <button onClick={() => handleTabChange(3)} className={'btn btn-light' + (activeTab === 3 ? ' active' : '')}>Actividades - Reporte de cajas</button>
      </div>

      <div>
        {activeTab === 1 && <Folios />}
        {activeTab === 2 && <DatoTecnico />}
        {activeTab === 3 && <ActividadesCajas />}
      </div>
    </div>
  );
};

export default Admin;